<template>
  <div class="lc">
    <div class="zbg1"></div>
    <div class="cbg3"></div>
    <div class="rbg2"></div>
    <div class="lt-left">
      <div class="l-item" v-for="(item, index) in defaultdata.slice(0, 4)" :key="index">
        <div class="i-top">
          <div class="t-title ellipsis" style="width: 120px" :title="item.value1">
            {{ item.value1 }}
          </div>
        </div>

        <div class="i-bottom">
          <div class="b-countPi">
            {{ item.value2 }}
          </div>
          <div class="b-countRenciTitle"> {{ item.value3 }} </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope75",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      //此页面的value2数据需要做限制，defaultdata需要做限制，最多展示6个
      title: "scope11-【组件】图文-4组数据8-完成",
      defaultdata: [
        { value1: "文本一", value2: "000", value3: "单位" },
        { value1: "文本二", value2: "000", value3: "单位" },
        { value1: "文本三", value2: "000", value3: "单位" },
        { value1: "文本四", value2: "000", value3: "单位" },
        { value1: "文本五", value2: "000", value3: "单位" },
        { value1: "文本六", value2: "000", value3: "单位" },
      ],
      valueMap: [
        { name: "名称", key: "value1" },
        { name: "数值", key: "value2" },
        { name: "单位", key: "value3" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n.slice(0, 4);
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    ...methods,
  },
  mounted() {
    this.setData()
  },
};
</script>

<style scoped lang="scss">
.lc {
  width: 435px;
  height: 240px;
  padding: 10px 0;
  position: relative;
  z-index: 401;
  overflow: hidden;
  // pointer-events: none !important;
  user-select: none !important;
  /* 禁止文本和图片被选中 */
}

.lt-left {
  width: 435px;
  height: 240px;
  position: relative;
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
  // flex-wrap: wrap;
}

.list {
  margin: 0;
}

.l-item {
  // width: calc(100% / 2);
  // height: calc(100% / 2);
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  z-index: 10;
}

.l-item:nth-child(1) {
  top: 27px;
  left: 20px;
  align-items: flex-start;

  .i-top {
    text-align: left;
  }

  .i-bottom {
    position: absolute;
    top: 36px;
    left: 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .b-countRenciTitle {
    margin-left: 5px;
  }
}

.l-item:nth-child(2) {
  top: 27px;
  right: 20px;
  align-items: flex-end;

  .i-top {
    text-align: right;
  }

  .i-bottom {
    position: absolute;
    top: 36px;
    right: 0px;
    display: flex; //不要删除，负责下面两行代码会不生效
    flex-direction: row-reverse;
    justify-content: flex-start;
  }

  .b-countRenciTitle {
    margin-right: 10px;
  }
}

.l-item:nth-child(3) {
  bottom: 27px;
  left: 20px;
  align-items: flex-start;

  .i-top {
    text-align: left;
  }

  .i-bottom {
    position: absolute;
    top: -36px;
    left: 0px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }

  .b-countRenciTitle {
    margin-left: 5px;
  }
}

.l-item:nth-child(4) {
  bottom: 27px;
  right: 20px;
  align-items: flex-end;

  .i-top {
    text-align: right;
  }

  .i-bottom {
    position: absolute;
    top: -36px;
    right: 0px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-start;
  }

  .b-countRenciTitle {
    margin-right: 10px;
  }
}

.t-title {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #7d9dcf;
  line-height: 28px;
}

.b-countPi {
  font-family: Benmo Ziyu;
  font-weight: 400;
  font-size: 18px;
  color: #e1edfd;
  line-height: 28px;
  max-width: 88px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.b-countRenciTitle {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 12px;
  color: #7d9dcf;
  line-height: 28px;
  max-width: 38px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.zbg1 {
  width: 126px; //+20 338 169
  height: 2px;
  background: url("../../assets/temimg2/line.png") no-repeat;
  background-size: 100%;
  position: absolute;
  top: 50%;
  left: 14%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.rbg2 {
  width: 126px; //+20 338 169
  height: 2px;
  background: url("../../assets/temimg2/line.png") no-repeat;
  background-size: 100%;
  position: absolute;
  top: 50%;
  right: 14%;
  transform: translate(50%, -50%) rotate(180deg);
  z-index: 1;
}

.cbg3 {
  width: 169px;
  height: 169px;
  box-sizing: border-box;
  background: url("../../assets/temimg2/tuwen4-main.png") no-repeat;
  background-size: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
</style>